import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.jsx";
import { msalInstance } from "./authConfig.js";
import "./index.css";

// Initialize MSAL and process any redirect response (auth code in URL hash)
// before rendering the app. This ensures the user is authenticated when
// ProtectedRoute checks on /config after a login redirect.
msalInstance.initialize().then(() => {
  return msalInstance.handleRedirectPromise();
}).then(() => {
  ReactDOM.createRoot(document.getElementById("root")).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}).catch((err) => {
  console.error("[MSAL] Initialization error:", err);
  ReactDOM.createRoot(document.getElementById("root")).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
});
